// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBES0RcbCEvMnytX9OJh990jpHv8yvzamg",
  authDomain: "openventure-4a282.firebaseapp.com",
  databaseURL: "https://openventure-4a282-default-rtdb.firebaseio.com",
  projectId: "openventure-4a282",
  storageBucket: "openventure-4a282.appspot.com",
  messagingSenderId: "177606778058",
  appId: "1:177606778058:web:80dcba713a6c7844dce833",
  measurementId: "G-DQ27VSTZQC"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);